import { BFormValidFeedback } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormValidFeedback = createEgBootstrapProxy(
  "EgBFormValidFeedback",
  BFormValidFeedback
);
